<template>
  <DashboardPanelTemplate
    :panel-size="panelSize"
    :panel-focus="panelFocus"
  >
    <h4 v-t="'Title'" />
    <div class="announcement-container">
      <div v-if="announcements.length === 0 && !isLoading" class="empty-state">
        No announcements, check back later!
      </div>
      <div
        v-for="(announcement, index) in announcements"
        :key="index"
        class="announcement-row"
      >
        <div class="announcement-text">
          <p>
            <span v-if="announcement.Date" class="announcement-date">
              {{ announcement.Date | date('MM/DD/YYYY') }}:
            </span>
            {{ announcement.Description }}
          </p>
        </div>
        <div class="announcement-read-more">
          <button
            :disabled="announcement.Link === null"
            class="btn btn-link"
            @click="readMore(announcement)"
          >
            {{ $t('ReadMore') }}
          </button>
        </div>
      </div>
    </div>
  </DashboardPanelTemplate>
</template>

<script>
import DashboardPanelTemplate from '@/components/layouts/DashboardPanelTemplate'
import { PendoWrapper } from '@/utils/pendoWrapper'
import { getTelemetryInstance } from '@/telemetry'

export default {
  name: 'AnnouncementsPanel',
  components: {
    DashboardPanelTemplate
  },
  props: {
    panelSize: {
      type: String,
      required: true
    },
    panelFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      announcements: [],
      pendoEventsLoaded: false,
      pendoCheckCount: 0,
      isLoading: this.loading
    }
  },
  beforeDestroy () {
    if (this.pendoInterval) {
      clearInterval(this.pendoInterval)
    }
  },
  async mounted () {
    this.checkPendoEvents()
  },
  methods: {
    checkPendoEvents () {
      this.pendoInterval = setInterval(() => {
        if (window.pendo && window.pendo.guides) {
          this.pendoEventsLoaded = true
          this.handlePendoEvents()
          clearInterval(this.pendoInterval)
        } else {
          this.pendoCheckCount++
          if (this.pendoCheckCount === 3) {
            this.isLoading = false
            clearInterval(this.pendoInterval)
          }
        }
      }, 1000)
    },
    handlePendoEvents () {
      const guides = PendoWrapper.getGuides()

      this.announcements = guides
        .filter(g => g.launchMethod === 'auto')
        .sort((a, b) => b.createdAt - a.createdAt)
        .map(g => ({
          Description: g.name,
          Guide: g,
          Date: g.createdAt
        }))

      this.isLoading = false
    },
    readMore (announcement) {
      getTelemetryInstance()?.trackEvent({
        name: 'MERCHANT_APP_DASHBOARD_PENDO_LOAD',
        properties: {
          description: announcement.Description,
          id: announcement.Guide.id
        }
      })
      announcement.Guide.launch()
    }
  },
  i18n: {
    messages: {
      'en-US': {
        Title: 'Announcements',
        ReadMore: 'Read More',
        ErrorMessage: 'Hm... we couldn\'t load your announcements. Please refresh your browser and if you have issues, let our support team know.'
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/../assets/scss/shipbob-custom/components/dashboard/_panel-announcements.scss';
</style>
